@if (page === Page.Media) {
  <app-media-access
    [showBrowserProblemLink]="showBrowserProblemLink"
    (next)="mediaAccessNext()">
  </app-media-access>
}

@if (page === Page.MediaError) {
  <app-media-error
    class="page page--media"
    [showBrowserProblemLink]="showBrowserProblemLink"
    >
  </app-media-error>
}

@if (page === Page.Record) {
  <app-voice-record
    #record
    (obtainMediaFailed)="onObtainMediaFailed()"
    (fileReady)="onFileReady($event)"
    [checks]="checks"
    [recordings]="recordings"
    [polling]="polling"
    [isPendingEvaluation]="isPendingEvaluation"
    [showStatuses]="showStatuses"
    [locale]="locale"
    [waitingForUploads]="waitingForUploads"
    >
  </app-voice-record>
}
